module.exports = __webpack_public_path__ + "static/to-do-tab-app-cover-052141fc89f3a67076c1e382446f5d89.png";